module.exports = __webpack_public_path__ + "img/patrocinadores.cbc6149c.jpg";